import { useUnit } from 'effector-react';
import { $profileFeatureStore } from '@lib/store';
import { DashboardCurrencies } from './dashboardCurrencies';
import { DashboardSpendingCurrency } from './dashboardSpendingCurrency';
import { DashboardExpenseCategories } from './dashboardExpenseCategories';
import { DashboardMerchants } from './dashboardMerchants';

export const CardTab = () => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  return (
    <>
      {profileFeatureStore.data?.dashboard?.viewCurrenciesSummary && <DashboardCurrencies />}
      {profileFeatureStore.data?.dashboard?.viewSpendingByCurrency && <DashboardSpendingCurrency />}
      {profileFeatureStore.data?.dashboard?.viewExpenseCategories && <DashboardExpenseCategories />}
      {profileFeatureStore.data?.dashboard?.viewMostUsedMerchants && <DashboardMerchants />}
    </>
  );
};
